export const APP_CATEGORIES_LIST = [
  {
    title: 'All',
    key: 'all',
  },
  {
    title: 'Your tools',
    key: 'custom',
  },
  {
    title: 'AI & Machine Learning',
    key: 'ai-machine-learning',
  },
  {
    title: 'Analytics & Data',
    key: 'analytics-data',
  },
  {
    title: 'Collaboration & Communication',
    key: 'collaboration-communication',
  },
  {
    title: 'CRM, Sales & Customer Support',
    key: 'crm-sales-support',
  },
  {
    title: 'Design & Creative Tools',
    key: 'design-creative',
  },
  {
    title: 'Document & File Management',
    key: 'document-file-management',
  },
  {
    title: 'E-commerce',
    key: 'ecommerce',
  },
  {
    title: 'Education & LMS',
    key: 'education-lms',
  },
  {
    title: 'Finance & Accounting',
    key: 'finance-accounting',
  },
  {
    title: 'HR & Recruiting',
    key: 'hr-recruiting',
  },
  {
    title: 'Marketing & Social Media',
    key: 'marketing-social-media',
  },
  {
    title: 'Productivity & Project Management',
    key: 'productivity-project-management',
  },
  {
    title: 'Scheduling & Booking',
    key: 'scheduling-booking',
  },
  {
    title: 'Security & Compliance',
    key: 'security-compliance',
  },
  {
    title: 'Developer Tools & DevOps',
    key: 'developer-tools-devops',
  },
  {
    title: 'Workflow Automation',
    key: 'workflow-automation',
  },
  {
    title: 'Entertainment & Media',
    key: 'entertainment-media',
  },
  {
    title: 'Other / Miscellaneous',
    key: 'miscellaneous',
  },
  {
    title: 'CRM',
    key: 'crm',
  },
]

export const APP_CATEGORY_KEYS = APP_CATEGORIES_LIST.reduce(
  (acc, category) => {
    acc[category.title.toLowerCase()] = category.key
    return acc
  },
  {} as Record<string, string>,
)

export const APP_CATEGORY_KEYS_REVERSE = Object.entries(
  APP_CATEGORY_KEYS,
).reduce(
  (acc, [key, value]) => {
    acc[value.toLowerCase()] = key
    return acc
  },
  {} as Record<string, string>,
)
